import type { UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { globalQueryClient } from 'queries/queryClient'
import type { Workflow } from 'types/automations'

import { QUERIES } from '@/enums/queries'

import { listWorkflows } from './services/loadWorkflows'

export const useLoadWorkflows = (
  options: UseQueryOptions<Workflow[], Error> = {}
): UseQueryResult<Workflow[], Error> => {
  return useQuery({
    queryKey: [QUERIES.AUTOMATIONS.WORKFLOWS.LIST],
    queryFn: ({ signal }: { signal?: AbortSignal }) => {
      return listWorkflows({ signal })
    },
    ...options,
  })
}

export const invalidateLoadWorkflows = async () => {
  await globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.AUTOMATIONS.WORKFLOWS.LIST],
    exact: false,
  })
}
